import { render, staticRenderFns } from "./filechange.vue?vue&type=template&id=5f152cfd&scoped=true&"
import script from "./filechange.vue?vue&type=script&lang=js&"
export * from "./filechange.vue?vue&type=script&lang=js&"
import style0 from "./filechange.vue?vue&type=style&index=0&id=5f152cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f152cfd",
  null
  
)

export default component.exports